import { showSuccessToast, ToastType } from 'contexts/apiRequestContext'
import { useUpdateManualWarrantyMutation } from 'contexts/creditNote/creditContext';
import React from 'react'
import { GenericActionHandler } from 'components/GenericActionHandler/GenericActionHandler';
import { useFormContext } from 'contexts/formContext';
import { WarrantyTypes } from 'services/creditNote';

type UpdateRevisionWarrrantyContainerProps = {
  setToast: React.Dispatch<React.SetStateAction<ToastType>>;
  onClose: () => void;
}

export const UpdateRevisionWarrrantyContainer = ({ onClose, setToast }: UpdateRevisionWarrrantyContainerProps) => {
  const { watch } = useFormContext();
  const creditNoteId = watch('id') as string;
  const creditProductId = watch('productId') as string;
  const warranty = (watch('warranty') ?? []) as WarrantyTypes[];
  
  const onSuccess = () => {
    showSuccessToast("Atualização de garantia manual realizada com sucesso", "", setToast);
    onClose(); 
  }

  const { mutateAsync, isLoading } = useUpdateManualWarrantyMutation(creditNoteId, onSuccess, setToast);

  const handleSubmit = async () => {
    const payload = {
      productId: creditProductId,
      warranty
    }
    await mutateAsync(payload);
  }

  return (
    <GenericActionHandler
      handleSubmit={handleSubmit}
      onClose={onClose}
      titleCancel='Cancelar'
      titleConfirm='Confirmar'
      isLoading={isLoading}
      isModal
    />
  )
}
